module.exports = __webpack_public_path__ + "static/media/video_verfication_audio.b820d6b3.mp3";